import { FeatureKey } from "@repo/utils";

export const remoteConfigDefaults: Record<string, string | number | boolean> = {
  [FeatureKey.HOME_PAGE]: false,
  [FeatureKey.NEW_DASHBOARD]: false,
  [FeatureKey.ENABLE_CHAT]: false,
  [FeatureKey.USER_VERTICAL]: "learn",
  [FeatureKey.AINA_DISABLE_MIC]: false,
  [FeatureKey.AINA_DISABLE_DOUBTS]: false,
  [FeatureKey.BRIDGE_COURSE_GRADE_MAPPING]: "{}",
  [FeatureKey.PROGRAM_JOURNEY]: "{}",
};
